import { render, staticRenderFns } from "./CardWidget.vue?vue&type=template&id=ece70606&scoped=true"
import script from "./CardWidget.vue?vue&type=script&lang=js"
export * from "./CardWidget.vue?vue&type=script&lang=js"
import style0 from "./CardWidget.vue?vue&type=style&index=0&id=ece70606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece70606",
  null
  
)

export default component.exports